import "./Practitioner.css";
import { useState, useEffect } from "react";

const Practitioner = (props) => {
  const [data, setData] = useState("");
  useEffect(() => {
    setData(props.getData());
  }, [data, props]);

  const [ind, setind] = useState("");
  return (
    <div className="observationContainerResource">
      {data?.objects?.map((item, index) => (
        <p
          key={index}
          className={`observationItem ${
            index === data?.objects?.length - 1 ? "lastRow" : ""
          } ${ind === index ? "active" : ""} cursor-pointer`}
          onClick={() => {
            props.setResourceListData(item);
            setind(index);
          }}
        >
          {item?.resource?.name[0]?.given[0]}{" "}
          {item?.resource?.name[0]?.given[1]}
        </p>
      ))}
    </div>
  );
};

export default Practitioner;
